import React, { useEffect, useState } from 'react';

import { CheckCircle, Redeem } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { CircularProgress } from '@mui/material';
import { Promotion,
  PromotionStatus,
  UserData,
  PromotionData,
  RewardDeliveryType } from './Promotion.model';

import { PromotionReward } from './PromotionReward';
import { ClaimedCode } from './ClaimedCode';
import { ClaimPromotionDialog } from './claim/ClaimPromotionDialog';

interface Props {
  promotion?: Promotion;
  showButton?: boolean;
}

export function PromotionCard({ promotion, showButton = true }: Props): JSX.Element {
  const [userData, setUserData] = useState<UserData>(null);
  const [promotionData, setPromotionData] = useState<PromotionData>(null);
  const [status, setStatus] = useState(null);
  const [open, setOpen] = React.useState(false);

  const { t } = useTranslation();

  useEffect(() => {
    if (promotion) {
      setPromotionData(promotion.promotionData);
      if (promotion.userData) {
        setUserData(promotion.userData);
        setStatus(promotion.userData.status);
      }
    }
  }, [promotion]);

  const handleClickOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  return (
    <div className='promotion-container'>
      <div className='rewards-container'>
        {promotionData?.rewards?.map((reward) => (
          <PromotionReward key={reward.displayName} reward={reward} />
        ))}
      </div>

      {promotionData?.rewardDeliveryType === RewardDeliveryType.Promocode
      && status === PromotionStatus.Claimed
      && !open
      && <ClaimedCode userData={userData} />}

      {promotionData?.rewardDeliveryType === RewardDeliveryType.Direct
      && status === PromotionStatus.Claimed
      && (
        <div className='reward-button'>
          <button type='button' data-cy='reward-claimed-btn' className='btn btn-primary-game claimed' disabled>
            <CheckCircle />
            {t('button.claimed')}
          </button>
        </div>
      )}

      {(showButton
        && (status !== PromotionStatus.Claimed || (status === PromotionStatus.Claimed && open)))
        && promotionData
         && (
           <div className='reward-button'>
             <button
               type='button'
               data-cy='claim-reward-btn'
               className={`btn btn-primary-game ${status === PromotionStatus.InProgress ? 'inProgress' : ''}`}
               onClick={handleClickOpen}
             >
               {status !== PromotionStatus.InProgress
                 ? (
                   <>
                     <Redeem />
                     {t('button.claim-now')}
                   </>
                 )
                 : <div className='loader'><CircularProgress /></div>}
             </button>
             <ClaimPromotionDialog
               isOpen={open}
               close={handleClose}
               promotion={promotion}
             />
           </div>
         )}
    </div>
  );
}
